
import { defineComponent } from 'vue'
import { mapMutations, mapState, mapActions } from 'vuex';
import moment from 'moment';

export default defineComponent({
    name: 'SolveDetails',
    methods: {
        toggleModal: function(){
            this.ToggleSolveModal();
        },
        parseTime(time: number, penalty: number): string{
            if (penalty == 2) return "DNF"
            var minutes = moment.duration(time).minutes();
            var formattedTime = minutes == 0 ? moment.utc(time).format('ss.SS') : moment.utc(time).format('mm:ss.SS')
            return penalty == 0 ? formattedTime : `${formattedTime}+`
        },

        // Penalties
        solveOk() {
            if (this.selectedSolve.penalty == 1){
                this.selectedSolve.time -= 2000    
            }
            this.selectedSolve.penalty = 0
            this.updateSolve(this.selectedSolve)
        },
        solvePlusTwo() {
            if (this.selectedSolve.penalty !== 1){
                this.selectedSolve.penalty = 1
                this.selectedSolve.time += 2000
                this.updateSolve(this.selectedSolve)
            }
        },
        solveDNF() {
            if (this.selectedSolve.penalty == 1){
                this.selectedSolve.time -= 2000
            }
            this.selectedSolve.penalty = 2
            this.updateSolve(this.selectedSolve)
        },
        removeSolve(){
            this.deleteSolve(this.selectedSolve);
        },
        ...mapMutations('modalModule', ['ToggleSolveModal']),
        ...mapActions('sessionsModule', ['updateSolve', 'deleteSolve']),

    },
    computed: {
        ...mapState('modalModule', ['solveModal', 'selectedSolve'])
    }
})
